import { render, staticRenderFns } from "./button-toggle.vue?vue&type=template&id=810dc5da&"
import script from "./button-toggle.vue?vue&type=script&lang=js&"
export * from "./button-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports